import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SigninSignupComponent } from './our-components/signin-signup/signin-signup/signin-signup.component';
import { AuthGuard } from './services/auth.guard';
import { RestPasswordComponent } from './our-components/signin-signup/rest-password/rest-password.component';
import { CreateMeetingComponent } from './master-config-components/micro-apps/crm/view-lead-details/lead-detail-component/create-components/create-meeting/create-meeting.component';
import { CreateCallComponent } from './master-config-components/micro-apps/crm/view-lead-details/lead-detail-component/create-components/create-call/create-call.component';
import { Title } from '@angular/platform-browser';
import { AddCustomizationsComponent } from './master-config-components/micro-apps/crm/view-lead-details/lead-detail-component/create-components/add-customizations/add-customizations.component';
import { HomeGuard } from './services/home.guard';
import { ViewRegistrationFormComponent } from './master-config-components/micro-apps/es-sub-modules/registrations/app-setting/settings-modules/view-registration-form/view-registration-form/view-registration-form.component';
import { ViewAdmissionFormComponent } from './master-config-components/micro-apps/es-sub-modules/student-management/app-settings/sm-setting-modules/view-admission-form/view-admission-form/view-admission-form.component';
import { VerifyPaymentComponent } from './master-config-components/micro-apps/es-sub-modules/student-management/verify-payment/verify-payment/verify-payment.component';
import { ViewInvoiceReceiptComponent } from './website-generation/view-invoice-receipt/view-invoice-receipt.component';

const routes: Routes = [
  // {
  //   path: 'business-type',
  //   loadChildren:()=>import('./our-components/b-type/b-type.module').then(m => m.BTypeModule)
  // },
  // {
  //   path: 'website-type',
  //   loadChildren :() => import('./our-components/w-type/w-type.module').then(m => m.WTypeModule)
  // },
  // {
  //   path: 'business-name',
  //   loadChildren:()=>import('./our-components/b-name/b-name.module').then(m=> m.BNameModule)
  // },
  // {
  //   path:'preview',
  //   component:PreviewComponent
  // },
  {
    path:'create-meeting',
    component:CreateMeetingComponent
  },
  {
    path:'create-call',
    component:CreateCallComponent
  },
  {
    path:'create-customization',
    component: AddCustomizationsComponent
  },
  {
    path:'admission',
    loadChildren:() => 
      import('./our-components/admission-payment/admission-payment.module').then(m => m.AdmissionPaymentModule)
  },
  {
    path:'collect-fee',
    loadChildren:() => 
      import('./our-components/fee-collect/fee-collect.module').then(m => m.FeeCollectModule)
  },
  {
    path:'kit',
    loadChildren:() => 
      import('./our-components/student-kit-distribution/student-kit-distribution.module').then(m => m.StudentKitDistributionModule)
  },
  // {
  //   path:'list-business',
  //   loadChildren:()=>import('../app/master-config-components/micro-apps/business/all-business/all-business.module').then(m => m.AllBusinessModule)
  // },
  {
    path: 'admin',
    loadChildren: () =>
      import(
        './master-config-components/master-config-mod/master-config-mod.module'
      ).then((module) => module.MasterConfigModModule),
      canActivate:[AuthGuard]
  },
  // {
  //   path:'masters',
  //   loadChildren:() =>
  //     import(
  //       './master-config-components/master/master.module'
  //     ).then(m => m.MasterModule)
  // },
  // {
  //   path:'signup',
  //   component:SigninSignupComponent,
  //   canActivate:[HomeGuard]
  // },
  {
    path:'reset-password',
    component:RestPasswordComponent
  },
  {
    path: 'registrationForm',
    component: ViewRegistrationFormComponent
  },
  {
    path: 'admissionForm',
    component: ViewAdmissionFormComponent
  },
  {
    path: 'verify-payment',
    component: VerifyPaymentComponent
  },
  {
    path:'',
    component:SigninSignupComponent,
    canActivate:[HomeGuard]
  },
  // {
  //   path:'',
  //   loadChildren:() => import('./our-components/custom-login-screen/custom-login-screen.module').then(m => m.CustomLoginScreenModule)
  // },
  // {
  //   path:'upload',
  //   // component:TemplateImagesUploadComponent
  //   loadChildren:() => import('./our-components/image-upload/image-upload.module').then(m => m.ImageUploadModule)
  // },
  // {
  //   path:'create-blog',
  //   component:CreateBlogsComponent
  // },
  {
    path:"stripe-success",
    loadChildren:() => import('./our-components/strip/strip-success/strip-success.module').then(m => m.StripSuccessModule)
  },
  // {
  //   path:'stripe-cancel',
  //   loadChildren:()=>import('./our-components/strip/strip-cancel/strip-cancel.module').then(m => m.StripCancelModule)
  // },
  // {
  //   path:'v3-generator',
  //   component:V3WebsiteGenerationComponent
  // },
  // {
  //   path:'v2-editor',
  //   component:V2EditorComponent
  // },
  // {
  //   path:'website-preview',
  //   component: WebsitePreviewComponent
  // },
  // {
  //   path: 'v3-editor',
  //   component: V3EditorComponent
  // },
  // {
  //   path: 'website-editor',
  //   component: V3GlobalStylesComponent
  // },
  {
    path:'invoice-view-receipt',
    component:ViewInvoiceReceiptComponent
  }

];

@NgModule({
  // imports: [RouterModule.forRoot(routes,{
  //   preloadingStrategy: PreloadAllModules
  // })],
  imports:[RouterModule.forRoot(routes,{preloadingStrategy: PreloadAllModules })],
  providers:[Title],
  exports: [RouterModule],
})
export class AppRoutingModule {}
